import { openDB, type DBSchema, type IDBPDatabase } from "idb";
import type { Product, Category, SaleRequest } from "../api/types";
import type { CartState } from "../domain/cart";

/** Durable on-device storage (§16): the offline sale queue, held sales and the catalogue
 * cache. One database per origin; every store is keyed so reads are cheap on a till. */

export type QueuedSale = {
  id: string;
  clientTxnId: string;
  payload: SaleRequest;
  createdAt: string;
  status: "pending" | "failed";
  lastError: string | null;
  branchId: number;
  cashierName: string;
  total: number;
};
export type ArchivedSale = QueuedSale & { discardedAt: string; discardReason: string; discardedBy: string };
export type HeldSale = { id: string; branchId: number; cashierId: number; cashierName: string; note: string | null; cart: CartState; createdAt: string; total: number; itemCount: number };
export type CatalogueSnapshot = { key: string; tenantId: number; products: Product[]; categories: Category[]; savedAt: string };

interface PosDB extends DBSchema {
  saleQueue: { key: string; value: QueuedSale; indexes: { byCreated: string } };
  saleArchive: { key: string; value: ArchivedSale };
  heldSales: { key: string; value: HeldSale; indexes: { byBranch: number } };
  catalogue: { key: string; value: CatalogueSnapshot };
}

let dbp: Promise<IDBPDatabase<PosDB>> | null = null;

export function db(): Promise<IDBPDatabase<PosDB>> {
  dbp ??= openDB<PosDB>("barapos", 1, {
    upgrade(d) {
      const q = d.createObjectStore("saleQueue", { keyPath: "id" });
      q.createIndex("byCreated", "createdAt");
      d.createObjectStore("saleArchive", { keyPath: "id" });
      const h = d.createObjectStore("heldSales", { keyPath: "id" });
      h.createIndex("byBranch", "branchId");
      d.createObjectStore("catalogue", { keyPath: "key" });
    },
  }).catch((e: unknown) => {
    dbp = null;
    throw e;
  });
  return dbp;
}
